export type Formula = 1 | 2 | 3 | 4 | 5;

export enum FormulaDescription {
  MAYOR = 'MAYOR',
  MENOR = 'MENOR',
  IGUAL = 'IGUAL',
  MAYOR10 = 'MAYOR10',
  MENOR10 = 'MENOR10',
}
